define('TescoMobile_Customer/js/view/account-modal-existing-user',['uiComponent', 'jquery', 'ko', 'Magento_Ui/js/modal/modal', 'mage/translate', 'mage/storage', 'Magento_Ui/js/model/messageList', 'Magento_Customer/js/customer-data', 'TescoMobile_Checkout/js/view/upgrade-modal-options', 'mage/url', 'Magento_ReCaptchaFrontendUi/js/registry', 'uiRegistry', 'mage/validation'], function (Component, $, ko, modal, $t, storage, globalMessageList, customerData, upgradeModalOptions, urlBuilder, registry, uiRegistry) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(true),
    messages: ko.observableArray([]),
    maskedMpn: ko.observable(''),
    maskedEmail: ko.observable(''),
    maxRetriesReached: ko.observable(false),
    codeHasBeenResent: ko.observable(false),
    otacRequested: ko.observable(false),
    form: null,
    otacType: ko.observable('text'),
    defaults: {
      isEmailOtacEnabled: false,
      isEmailOtacForced: false,
      maskedMpnText: $t('Please enter the temporary code we\'ve just sent to the main account holder (%1).'),
      maskedEmailText: $t('Please enter the temporary code we\'ve just emailed to the main account holder (%1).'),
      formKey: $.mage.cookies.get('form_key'),
      step: 'login',
      changePasswordFormTemplate: 'TescoMobile_Customer/account/password/change/form',
      formData: {}
    },
    initialize: function () {
      this._super();
      const self = this;
      this.formMessage = ko.computed(function () {
        return !self.isEmailOtac() ? self.maskedMpn() : self.maskedEmail();
      }, this);
      return this;
    },
    initObservable: function () {
      return this._super().observe(['isEmailOtacEnabled', 'isEmailOtacForced', 'step', 'formData']);
    },
    setModalElement: function (element) {
      var options = {
        modalClass: 'login-existing show-close',
        responsive: true,
        innerScroll: true,
        type: 'slide',
        clickableOverlay: false,
        opened: function (a, b) {
          this._updateContent(element);
        }.bind(this),
        closed: function () {
          $('body').trigger('login-popup-closed');
        }
      };
      this.modalWindow = element;
      modal(options, $(this.modalWindow));
      $('.show-hide-pw').on('click', function (e) {
        var prev = this.parentElement.querySelector('input');
        if (prev.type == 'password') {
          prev.type = 'text';
          this.textContent = $t('Hide');
        } else {
          prev.type = 'password';
          this.textContent = $t('Show');
        }
      });
      $('.type-switch.monthly').addClass('active');
      $('.account-type').on('click', function (e) {
        $('.type-switch').removeClass('active');
        $(this).hasClass('monthly') ? $('.type-switch.monthly').addClass('active') : $('.type-switch.payg').addClass('active');
      });
      $('body').on('customer-login-existing', function (e, data) {
        this.form = data;
        $(element).modal('openModal');
      }.bind(this));
      $('body').on('guest-upgrade', function () {
        $(element).modal('openModal');
      });
      $('body').on('customer-ajax-logged-in', function (e, data) {
        this.form = data;
        $(element).modal('closeModal');
      });
      $('body').on('close-all-modals-keep-loader', function (e, elem) {
        $(element).modal('closeModal');
      }.bind(this));
      $('body').on('existing-customer-login-paym', function () {
        $(element).modal('closeModal');
        upgradeModalOptions().triggerMigrateToPayMonthly();
      }.bind(this));
    },
    login: function (formUiElement, event) {
      var loginData = {},
        self = this,
        formElement = $(event.currentTarget),
        formDataArray = formElement.serializeArray();
      event.stopPropagation();
      formDataArray.forEach(function (entry) {
        loginData[entry.name] = entry.value;
      });
      if (formElement.validation() && formElement.validation('isValid')) {
        this.isLoading(true);
        self.actionLogin(loginData);
        $('body').trigger('dl-auth-login');
        self.messages([]);
      }
      return false;
    },
    triggerQuoteAsMigration: function () {
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/setcustomerisnew'),
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function () {
          $('body').trigger('existing-customer-login-paym');
        }
      });
    },
    auth: function (formUiElement, event) {
      $('body').trigger('dl-2fa-submit');
      var self = this,
        formElement = $(event.currentTarget);
      event.stopPropagation();
      if (formElement.validation() && formElement.validation('isValid')) {
        this.isLoading(true);
        self.messages([]);
        self.submitOtac(formUiElement, event);
      }
    },
    getPasswordConfig: function (data) {
      let config = data,
        self = this;
      config.changePassword = function (formUiElement, event) {
        let passwordData = {},
          formElement = $(event.currentTarget),
          formDataArray = formElement.serializeArray();
        event.stopPropagation();
        formDataArray.forEach(function (entry) {
          passwordData[entry.name] = entry.value;
        });
        if (formElement.validation() && formElement.validation('isValid')) {
          self.isLoading(true);
          self.messages([]);
          $.ajax({
            url: self.getChangePasswordUrl(),
            type: 'POST',
            data: passwordData,
            dataType: 'json',
            encode: true
          }).always(function (response) {
            if (!response.errors) {
              $('body').trigger('change-password-submit');
              self.isLoading(false);
              self.step('login');
              self.messages([{
                type: 'success',
                text: $t(response.message)
              }]);
            }
          });
        }
      };
      config.requestUrl = '';
      return config;
    },
    submitOtac: function (formUiElement, event) {
      var authData = {},
        self = this,
        formElement = $(event.currentTarget),
        formDataArray = formElement.serializeArray(),
        otac = '';
      otac = $(event.currentTarget).find('#otac_code').val();
      storage.post(`${this.getValidateOtacUrl()}?otac_code=${otac}`).done(function (response) {
        self.codeHasBeenResent(false);
        self.maxRetriesReached(response.max_retries_reached === true);
        if (response.errors) {
          self.messages([{
            type: 'error',
            text: $t(response.message)
          }]);
        } else {
          customerData.invalidate(['customer']);
          $('body').trigger('otac-ajax-logged-in-success', self.form);
          $('body').trigger('customer-ajax-logged-in', self.form);
        }
      }).fail(function () {
        self.messages([{
          type: 'error',
          text: $t('Could not authenticate. Please try again later')
        }]);
      }).always(function () {
        self.isLoading(false);
      });
    },
    requestNew: function (loginData) {
      var self = this;
      this.isLoading(true);
      storage.post(this.getRequestNewUrl()).done(function (response) {
        self.codeHasBeenResent(false);
        self.maxRetriesReached(false);
        self.otacRequested(true);
        if (response.errors) {
          self.messages([{
            type: 'error',
            text: $t(response.message)
          }]);
        }
        self.isLoading(false);
      }).fail(function () {
        self.messages([{
          type: 'error',
          text: $t('Could not authenticate. Please try again later')
        }]);
      }).always(function () {
        self.isLoading(false);
      });
    },
    resend: function (loginData) {
      $('body').trigger('dl-2fa-resend');
      var self = this;
      this.isLoading(true);
      storage.post(self.getResendUrl()).done(function (response) {
        self.maxRetriesReached(false);
        if (response.errors) {
          self.messages([{
            type: 'error',
            text: $t(response.message)
          }]);
        } else {
          self.codeHasBeenResent(true);
        }
        self.isLoading(false);
      }).fail(function () {
        self.messages([{
          type: 'error',
          text: $t('Could not authenticate. Please try again later')
        }]);
      }).always(function () {
        self.isLoading(false);
      });
    },
    actionLogin: function (loginData) {
      let self = this;
      storage.post('customer/ajax/login', JSON.stringify(loginData)).done(function (response) {
        if (response.errors) {
          var _response$error_code;
          self.messages([{
            type: (_response$error_code = response === null || response === void 0 ? void 0 : response.error_code) !== null && _response$error_code !== void 0 ? _response$error_code : 'error',
            text: $t(response.message)
          }]);
          self.resetRecaptchaTokenFields();
        } else if ((response === null || response === void 0 ? void 0 : response.code) === 'temporary_password') {
          self.formData(self.getPasswordConfig(uiRegistry.get('password-change-form')));
          self.step('change_password');
        } else if ((response === null || response === void 0 ? void 0 : response.code) === 'auth') {
          var _response$is_email_ot, _response$is_email_ot2;
          self.step('otac');
          self.maskedMpn(self.maskedMpnText.replace('%1', response.mpn));
          self.maskedEmail(self.maskedEmailText.replace('%1', response.email));
          self.isEmailOtacEnabled((_response$is_email_ot = response === null || response === void 0 ? void 0 : response.is_email_otac_enabled) !== null && _response$is_email_ot !== void 0 ? _response$is_email_ot : false);
          self.isEmailOtacForced((_response$is_email_ot2 = response === null || response === void 0 ? void 0 : response.is_email_otac_forced) !== null && _response$is_email_ot2 !== void 0 ? _response$is_email_ot2 : false);
          customerData.get('customer').subscribe(function (data) {
            if (!self.otacRequested()) {
              if (self.isEmailOtacForced()) {
                self.switchToEmail();
              } else {
                self.requestNew(loginData);
              }
            }
          });
          $('body').trigger('dl-2fa-text-view');
        } else if ((response === null || response === void 0 ? void 0 : response.code) === 'login') {
          $('body').trigger('customer-ajax-logged-in', self.form);
        }
        customerData.invalidate(['cart']);
      }).fail(function () {
        self.messages([{
          type: 'error',
          text: $t('Could not authenticate. Please try again later')
        }]);
      }).always(function () {
        self.isLoading(false);
      });
    },
    _updateContent: function (element) {
      this.isLoading(false);
    },
    resetRecaptchaTokenFields: function () {
      var i,
        captchaList = registry.captchaList(),
        tokenFieldsList = registry.tokenFields();
      for (i = 0; i < captchaList.length; i++) {
        grecaptcha.reset(captchaList[i]);
        if (tokenFieldsList[i]) {
          tokenFieldsList[i].value = '';
        }
      }
    },
    getResendUrl: function () {
      return this.otacType() === 'text' ? 'sso/otac/resendAjax' : 'sso/otac/resendEmailAjax';
    },
    getRequestNewUrl: function () {
      return this.otacType() === 'text' ? 'sso/otac/requestAjax' : 'sso/otac/requestEmailAjax';
    },
    getValidateOtacUrl: function () {
      return this.otacType() === 'text' ? 'sso/otac/validatePostAjax' : 'sso/otac/validateEmailPostAjax';
    },
    getChangePasswordUrl: function () {
      return urlBuilder.build('customer/password/changePostAjax');
    },
    switchToEmail: function (config, event) {
      this.otacType('email');
      this.requestNew();
      $('body').trigger('dl-2fa-email-view');
      if ($(event.currentTarget).hasClass('no-device')) {
        $('body').trigger('dl_2fa_email_request_no_device');
      } else if ($(event.currentTarget).hasClass('no-code')) {
        $('body').trigger('dl_2fa_email_request_no_code');
      }
    },
    isEmailOtac: function () {
      return this.otacType() === 'email';
    },
    showOtacEmailActions: function () {
      return this.isEmailOtacEnabled() && !this.isEmailOtac();
    }
  });
});

